import { render, staticRenderFns } from "./customizable-link.vue?vue&type=template&id=0780f1ad&scoped=true&"
import script from "./customizable-link.vue?vue&type=script&lang=js&"
export * from "./customizable-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0780f1ad",
  null
  
)

export default component.exports